import { gsap } from 'gsap';
import { SplitText } from 'gsap/dist/SplitText';
import { WbScroller } from '../../webit_modules/wb-scroller/src';

export class WbAnimations {
  constructor() {
    const _this = this;
    this.isFirstLoad = true;

    gsap.registerPlugin(SplitText);
    this.addScroller();
    this.removeInitialLoading();
    this.addAnims();

    this.init();
    document.addEventListener('_before_page_loaded', _this.init.bind(_this));
  }

  init() {
    return new Promise((resolve, reject) => {
      if (!this.isFirstLoad) this.addAnims();
      this.isFirstLoad = false;
      resolve();
    });
  }

  wait(duration = 25) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, duration);
    });
  }

  addScroller() {
    this.scroller = window.WbScroller = new WbScroller();
    this.scroller.init();
  }

  removeInitialLoading() {
    const overlay = document.querySelector('.wb-load-overlay--initial');

    gsap.to(overlay, {
      opacity: 0,
      duration: 0.25,
      delay: 0,
      onComplete: () => {
        overlay._remove();
      },
    });
  }

  addAnims() {
    this.addHomeBannerAnims();
    this.addHomeMediaTextAnims();
    this.addFeaturedLinksAnims();
    this.addTextGalleryAnims();
    this.addFeaturedCardsAnims();
  }

  addHomeBannerAnims() {
    const splitText = new SplitText('.wb-home-banner .wb-side-title__h1', { type: 'lines' });

    this.scroller.addAnim({
      element: '.wb-side-title__title',
      trigger: '.wb-home-banner',
      timeline: [{ effect: 'fadeIn', to: { delay: 0.5 } }],
      horizontal: true,
    });

    this.scroller.addAnim({
      element: [...splitText.lines, ...document.querySelectorAll('.wb-home-banner .wb-button')],
      trigger: '.wb-home-banner',
      timeline: [{ effect: 'fadeInRight', to: { stagger: 0.1 } }],
      horizontal: true,
      batch: true,
    });

    this.scroller.addAnim({
      element: '.wb-home-banner__media--1',
      trigger: '.wb-home-banner',
      timeline: [{ set: { x: '-15vw', opacity: 0 }, to: { x: 0, opacity: 1, duration: 1 } }],
      horizontal: true,
    });

    this.scroller.addAnim({
      element: '.wb-home-banner__media--1 img',
      trigger: '.wb-home-banner',
      timeline: [{ set: { scale: 1.25 }, to: { scale: 1 } }],
      horizontal: true,
      scrollTrigger: {
        scrub: true,
      },
    });

    this.scroller.addAnim({
      element: '.wb-home-banner__media--2',
      trigger: '.wb-home-banner',
      timeline: [{ effect: 'fadeIn', to: { delay: 0.5 } }],
      horizontal: true,
    });

    this.scroller.addAnim({
      element: '.wb-home-banner__media--2 img',
      trigger: '.wb-home-banner',
      timeline: [{ set: { scale: 1.25 }, to: { scale: 1 } }],
      horizontal: true,
      scrollTrigger: {
        scrub: true,
      },
    });
  }

  addHomeMediaTextAnims() {
    this.scroller.addAnim({
      element: '.wb-home-media-text__media--1',
      trigger: '.wb-home-media-text',
      timeline: [{ effect: 'fadeIn' }],
      horizontal: true,
    });

    this.scroller.addAnim({
      element: '.wb-home-media-text__media--2',
      trigger: '.wb-home-media-text',
      timeline: [{ set: { x: '-30vw', opacity: 0 }, to: { x: 0, opacity: 1, duration: 1 } }],
      horizontal: true,
    });

    this.scroller.addAnim({
      element: '.wb-home-media-text__media--2 img',
      trigger: '.wb-home-media-text',
      timeline: [{ set: { scale: 1.25 }, to: { scale: 1 } }],
      horizontal: true,
      scrollTrigger: {
        scrub: true,
      },
    });

    this.scroller.addAnim({
      element: '.wb-home-media-text__content',
      trigger: '.wb-home-media-text',
      timeline: [{ effect: 'fadeIn' }],
      horizontal: true,
    });

    this.scroller.addAnim({
      element: '.wb-home-media-text__content > *',
      trigger: '.wb-home-media-text',
      timeline: [{ effect: 'fadeInUp', to: { stagger: 0.1 } }],
      batch: true,
      horizontal: true,
    });
  }

  addFeaturedLinksAnims() {
    this.scroller.addAnim({
      element: '.wb-home-featured-links__list__el',
      trigger: '.wb-home-featured-links',
      timeline: [{ set: { x: '20vw', opacity: 0 }, to: { x: 0, opacity: 1, stagger: 0.1 } }],
      horizontal: true,
      batch: true,
    });

    this.scroller.addAnim({
      element: '.wb-side-title__title',
      trigger: '.wb-home-featured-links',
      timeline: [{ effect: 'fadeIn', to: { delay: 0.5 } }],
      horizontal: true,
    });
  }

  addTextGalleryAnims() {
    const splitText = new SplitText('.wb-home-text-gallery .wb-side-title__h1', { type: 'lines' });

    this.scroller.addAnim({
      element: [
        ...splitText.lines,
        ...document.querySelectorAll('.wb-home-text-gallery .wb-button'),
      ],
      trigger: '.wb-home-text-gallery',
      timeline: [{ effect: 'fadeInRight', to: { stagger: 0.1 } }],
      horizontal: true,
      batch: true,
    });

    this.scroller.addAnim({
      element: document.querySelectorAll('.wb-home-text-gallery__media'),
      trigger: '.wb-home-text-gallery',
      timeline: [{ effect: 'fadeIn', to: { stagger: 0.1 } }],
      horizontal: true,
      batch: true,
    });
  }

  addFeaturedCardsAnims() {
    this.scroller.addAnim({
      element: '.wb-home-featured-cards__content',
      trigger: '.wb-home-featured-cards',
      timeline: [{ effect: 'fadeIn' }],
      horizontal: true,
    });

    this.scroller.addAnim({
      element: '.wb-home-featured-cards__content > *',
      trigger: '.wb-home-featured-cards',
      timeline: [{ effect: 'fadeInUp', to: { stagger: 0.1 } }],
      batch: true,
      horizontal: true,
    });
  }
}
